const DEFAULT_LOGIN_PATH = '/auth1'
const DEFAULT_HOME_PATH = '/ops/home'

export function isKeycloakSsoEnabled () {
  return process.env.VUE_APP_ENABLE_KEYCLOAK_SSO === 'true'
}

export function getSafeReturnTo (returnTo, fallback = DEFAULT_HOME_PATH) {
  if (!returnTo || typeof returnTo !== 'string') return fallback
  if (!returnTo.startsWith('/') || returnTo.startsWith('//')) return fallback
  if (returnTo.startsWith('/auth/bootstrap') || returnTo.startsWith('/auth/callback') || returnTo.startsWith('/callback')) return fallback

  return returnTo
}

export function getAuthRedirectPath (returnTo = DEFAULT_HOME_PATH) {
  if (!isKeycloakSsoEnabled()) return DEFAULT_LOGIN_PATH
  return `/auth/callback?returnTo=${encodeURIComponent(getSafeReturnTo(returnTo))}`
}

export function getCurrentReturnTo () {
  if (typeof window === 'undefined') return DEFAULT_HOME_PATH

  return getSafeReturnTo(`${window.location.pathname}${window.location.search}`)
}
